import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const eventTypes = [
  "keypress",
  "mousemove",
  "mousedown",
  "scroll",
  "touchmove",
  "pointermove",
  "touchstart",
];

const time = 120000;

const addEventListeners = (listener: EventListenerOrEventListenerObject) => {
  eventTypes.forEach((type) => {
    window.addEventListener(type, listener, false);
  });
};

const removeEventListeners = (listener: EventListenerOrEventListenerObject) => {
  if (listener) {
    eventTypes.forEach((type) => {
      window.removeEventListener(type, listener, false);
    });
  }
};

interface Props {}

const IdleWatcher: React.FC<Props> = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const createTimeout = () =>
      setTimeout(() => {
        navigate("/");
        resetTimeout();
      }, time);

    const resetTimeout = () => {
      clearTimeout(timeout);
      timeout = createTimeout();
    };

    // Initialization
    let timeout = createTimeout();
    addEventListeners(resetTimeout);

    // Cleanup
    return () => {
      removeEventListeners(resetTimeout);
      clearTimeout(timeout);
    };
  }, []);

  return null;
};

export default IdleWatcher;
